import React from 'react';
import { tabsType } from '../libs/typeInterface';
import ProductFeatures from '../ProductDetails/ProductFeatures';

interface IAboutProduct {
  productSelected: string;
  tabs: tabsType[];
}

const AboutProduct = (props: IAboutProduct) => {
  const { productSelected, tabs } = props;

  let customStyle = {};

  if (productSelected === 'serum') {
    customStyle = {
      backgroundPosition: 'right top',
      backgroundSize: '40%'
    };
  }

  if (productSelected === 'facewash') {
    customStyle = {
      backgroundPosition: '90% top',
      backgroundSize: '40%'
    };
  }

  if (productSelected === 'cream') {
    customStyle = {
      backgroundPosition: '90% top',
      backgroundSize: '35%'
    };
  }

  return (
    <>
      <div
        style={customStyle}
        className={
          `w-full relative bg-contain lg:bg-no-repeat ${
            productSelected === 'serum' && ' lg:bg-serum '
          }` +
          `${productSelected === 'facewash' && ' lg:bg-facewash '}` +
          `${productSelected === 'cream' && ' lg:bg-cream '}`
        }
      >
        <section className="xs:px-4 lg:px-0 relative w-full flex flex-col items-center justify-start lg:h-100 lg:container lg:mx-auto xs:mb-5">
          <div className="w-full flex xs:flex-col lg:flex-row">
            <div className="xs:w-full lg:w-1/2 flex flex-col">
              <ProductFeatures isInner tabs={tabs} />
            </div>
            <div className="w-1/2 flex items-start justify-end">
              {/* {productSelected === 'serum' && (
                <img
                  src="/images/hand-drop.png"
                  className="w-full h-full object-contain"
                  alt="hand-drop"
                />
              )}

              {productSelected === 'facewash' && (
                <img
                  src="/images/face-wash.png"
                  className="w-full h-full object-contain"
                  alt="facewash"
                />
              )}

              {productSelected === 'cream' && (
                <img src="/images/cream.png" className="w-full h-full object-contain" alt="cream" />
              )} */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutProduct;
